import { apiEndpoint } from '@/config';
import { useRouter } from '@/i18n/routing';
import { useAuth } from '@/lib/auth/use-auth';
import { fetcher } from '@/lib/swr';
import {
  ActivityByMe,
  ApiErrorResponse,
  ApiSuccessResponse,
} from '@hidayahlab/academy-suite-corelib';
import useSWR from 'swr';

export function useGetMyCourseActivities(courseId?: number) {
  const { token } = useAuth();
  const router = useRouter();

  const shouldFetch = !!token && !!courseId;
  const apiUrl = shouldFetch
    ? `${apiEndpoint}/activities/me/course/${courseId}`
    : null;

  const { data, error, isLoading } = useSWR<
    ApiSuccessResponse<ActivityByMe>,
    ApiErrorResponse
  >(apiUrl, (url: string) => fetcher(url, token));

  if (data?.statusCode === 401) {
    router.push('/logout');
  }

  return {
    data: data?.data,
    isLoading,
    isError: error,
  };
}
